import { render, staticRenderFns } from "./WidgetButton.vue?vue&type=template&id=67fa6cbe&scoped=true"
import script from "./WidgetButton.vue?vue&type=script&lang=js"
export * from "./WidgetButton.vue?vue&type=script&lang=js"
import style0 from "./WidgetButton.vue?vue&type=style&index=0&id=67fa6cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fa6cbe",
  null
  
)

export default component.exports